import { useEffect, useState } from 'react';
import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { observer } from 'mobx-react-lite';
import CEditor from 'src/components/editor/CEditor';
import { RHFTextField } from 'src/components/hook-form';
import { UploadErrorMessage } from 'src/components/hook-form/UploadErrorMessage';
import RHFUploadImage from 'src/components/hook-form/uploadImage/RHFUploadImage';
import { FormInnerContainer, FormItem, FormLabel, FormRow } from 'src/layouts/form/FormLayout';

export const Contents = observer(() => {
  const {
    getValues,
    setValue,
    formState: { errors },
  } = useFormContext();
  const { t } = useTranslation();
  const [desktopImageFiles, setDesktopImageFiles] = useState<Array<File | string>>([]);
  const [mobileImageFiles, setMobileImageFiles] = useState<Array<File | string>>([]);

  useEffect(() => {
    setDesktopImageFiles(getValues('desktopImgPath'));
    setMobileImageFiles(getValues('mobileImgPath'));
  }, []);

  return (
    <FormInnerContainer>
      <FormLabel>{t('common.form.section.content')}</FormLabel>
      <FormRow sx={{ gridTemplateColumns: '1fr' }}>
        <FormItem>
          <RHFTextField label={t('business.form.title')} name="title" />
        </FormItem>
      </FormRow>
      <FormRow sx={{ gridTemplateColumns: '1fr' }}>
        <FormItem>
          <RHFTextField label={t('business.form.summary')} name={'summary'} multiline rows={3} />
        </FormItem>
      </FormRow>
      <FormRow sx={{ gridTemplateColumns: '1fr' }}>
        <FormItem>
          <CEditor name={'descript'} placeholder={t('business.form.descript')} />
        </FormItem>
      </FormRow>
      <FormInnerContainer>
        <FormLabel>{t('business.form.desktopImage')}</FormLabel>
        <FormRow sx={{ gridTemplateColumns: '1fr' }}>
          <FormItem>
            <RHFUploadImage
              name="desktopImgPath"
              maxFiles={5}
              files={desktopImageFiles}
              onChange={(newFile: Array<File | string>) => {
                setDesktopImageFiles(newFile);
                setValue('desktopImgPath', newFile, {
                  shouldValidate: true,
                  shouldDirty: true,
                });
              }}
            />
            {errors.desktopImgPath?.message && (
              <UploadErrorMessage message={String(errors.desktopImgPath.message)} />
            )}
          </FormItem>
        </FormRow>
      </FormInnerContainer>

      <FormInnerContainer>
        <FormLabel>{t('business.form.mobileImage')}</FormLabel>
        <FormRow sx={{ gridTemplateColumns: '1fr' }}>
          <FormItem>
            <RHFUploadImage
              name="mobileImgPath"
              maxFiles={5}
              files={mobileImageFiles}
              onChange={(newFile: Array<File | string>) => {
                setMobileImageFiles(newFile);
                setValue('mobileImgPath', newFile, {
                  shouldValidate: true,
                  shouldDirty: true,
                });
              }}
            />
            {errors.mobileImgPath?.message && (
              <UploadErrorMessage message={String(errors.mobileImgPath.message)} />
            )}
          </FormItem>
        </FormRow>
      </FormInnerContainer>
    </FormInnerContainer>
  );
});
